import { render, staticRenderFns } from "./ChooseRole.vue?vue&type=template&id=de139550&scoped=true&"
import script from "./ChooseRole.vue?vue&type=script&lang=js&"
export * from "./ChooseRole.vue?vue&type=script&lang=js&"
import style0 from "./ChooseRole.vue?vue&type=style&index=0&id=de139550&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de139550",
  null
  
)

export default component.exports